import React, { Component } from 'react'
import styled from 'styled-components'

import Logic from '../FeedbackModalV2/logic'

import Loading from 'components/Loading'
import ButtonOutlineV2 from '../ButtonOutlineV2'
import ButtonGradientV2 from '../ButtonGradientV2'
import BoxRadioV2 from '../BoxRadioV2'

import IcReview from '../FeedbackModalV2/images/ic-review.component.svg'
import IcCry from '../FeedbackModalV2/images/ic-cry.component.svg'
import IcSmile from '../FeedbackModalV2/images/ic-smile.component.svg'
import IcSad from '../FeedbackModalV2/images/ic-sad.component.svg'
import IcNeutral from '../FeedbackModalV2/images/ic-neutral.component.svg'
import IcHappy from '../FeedbackModalV2/images/ic-happy.component.svg'

/**
 * Conteúdo do inquérito de satisfação SEM a moldura de modal.
 *
 * É o mesmo conteúdo interno da FeedbackModalV2 (formulário + painel verde),
 * mas sem overlay/posicionamento/botão de fechar, para poder ser colocado
 * dentro de uma modal do projeto pai (ou de qualquer outro contentor).
 *
 * A FeedbackModalV2 mantém-se intacta para uso dentro desta aplicação.
 *
 * Props:
 *  - width: número (largura do viewport). >= 1000 mostra o painel lateral.
 *  - onClose: callback opcional chamado após submeter com sucesso (e, se
 *    showCancel estiver ativo, também ao cancelar).
 *  - showCancel: bool (default false). Mostra o botão "Cancelar". Faz sentido
 *    dentro de uma modal desta app; num iframe/micro-serviço normalmente não.
 */
@Logic
export default class FeedbackContent extends Component {
  handleCancel = () => {
    const { onClose } = this.props
    const { resetForm } = this.actions

    resetForm()
    onClose && onClose()
  }

  disableSubmitButton = () => {
    return false
  }

  renderLoading() {
    const { loading } = this.props
    return loading ? <Loading /> : null
  }

  renderForm = () => {
    const { loading, formValues } = this.props
    const { setFormValues, sendFeedback } = this.actions

    return !loading ? (
      <Form>
        <Content>
          <InputSection>
            <TextsWrapper>
              <Title>Está satisfeito com a informação disponibilizada?</Title>
              <Description>
                Sendo 1 (nada satisfeito) e 5 (muito satisfeito)
              </Description>
            </TextsWrapper>
            <RadioWrappers>
              <BoxRadioV2
                onClick={() => setFormValues({ rating: 1 })}
                name='Feedback1'
                selected={formValues.rating === 1}>
                <IcCry />
                <RadioText>1</RadioText>
              </BoxRadioV2>
              <BoxRadioV2
                onClick={() => setFormValues({ rating: 2 })}
                name='Feedback2'
                selected={formValues.rating === 2}>
                <IcSad />
                <RadioText>2</RadioText>
              </BoxRadioV2>
              <BoxRadioV2
                onClick={() => setFormValues({ rating: 3 })}
                name='Feedback3'
                selected={formValues.rating === 3}>
                <IcNeutral />
                <RadioText>3</RadioText>
              </BoxRadioV2>
              <BoxRadioV2
                onClick={() => setFormValues({ rating: 4 })}
                name='Feedback4'
                selected={formValues.rating === 4}>
                <IcSmile />
                <RadioText>4</RadioText>
              </BoxRadioV2>
              <BoxRadioV2
                onClick={() => setFormValues({ rating: 5 })}
                name='Feedback5'
                selected={formValues.rating === 5}>
                <IcHappy />
                <RadioText>5</RadioText>
              </BoxRadioV2>
            </RadioWrappers>
          </InputSection>

          <InputSection>
            <TextsWrapper>
              <Title lighter>
                Recomendaria o Poupa Energia a um familiar ou amigo?
              </Title>
            </TextsWrapper>
            <RadioWrappers>
              <BoxRadioV2
                onClick={() => setFormValues({ recommendation: 'yes' })}
                name='recommendation _yes'
                selected={formValues.recommendation === 'yes'}>
                <RadioText>Sim</RadioText>
              </BoxRadioV2>
              <BoxRadioV2
                onClick={() => setFormValues({ recommendation: 'no' })}
                name='recommendation _no'
                selected={formValues.recommendation === 'no'}>
                <RadioText>Não</RadioText>
              </BoxRadioV2>
              <BoxRadioV2
                onClick={() => setFormValues({ recommendation: 'maybe' })}
                name='recommendation_maybe'
                selected={formValues.recommendation === 'maybe'}>
                <RadioText>Talvez</RadioText>
              </BoxRadioV2>
            </RadioWrappers>
          </InputSection>

          <InputSection>
            <TextsWrapper>
              <Title lighter>
                Por favor, deixe-nos algum comentário adicional ou sugestão de
                melhoria
              </Title>
            </TextsWrapper>
            <TextArea
              id='txtArea'
              rows='5'
              name='observations'
              value={formValues.observations}
              onChange={(e) => setFormValues({ observations: e.target.value })}
              placeholder='Escreva um comentário e ajude-nos a melhorar.'></TextArea>
          </InputSection>
        </Content>
        <BtnsWrapper>
          {this.props.showCancel && (
            <ButtonOutlineV2
              style={{ width: '140px ' }}
              onClick={() => this.handleCancel()}>
              Cancelar
            </ButtonOutlineV2>
          )}
          <ButtonGradientV2
            style={{ width: '140px ' }}
            onClick={(e) => {
              e.preventDefault()
              sendFeedback()
            }}
            disabled={this.disableSubmitButton()}>
            Submeter
          </ButtonGradientV2>
        </BtnsWrapper>
      </Form>
    ) : null
  }

  render() {
    const { width } = this.props

    return width >= 1000 ? (
      <Wrapper>
        <FormWrapper>
          {this.renderLoading()}
          {this.renderForm()}
        </FormWrapper>
        <Advice>
          <IcReview />
          <AdviceTitle>Partilhe a sua opinião</AdviceTitle>
          <AdviceText>
            A sua opinião é importante para nós. Deixe-nos o seu feedback e
            ajude-nos a melhorar.
          </AdviceText>
        </Advice>
      </Wrapper>
    ) : (
      <FormWrapper>
        {this.renderLoading()}
        {this.renderForm()}
      </FormWrapper>
    )
  }
}

const Wrapper = styled.div`
  display: flex;
  align-items: stretch;
  gap: 16px;
  width: 100%;
  height: 100%;
`

const FormWrapper = styled.div`
  display: flex;
  flex-grow: 1;
  align-self: stretch;
  border: 1px solid #ececec;
`

const Form = styled.form`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  width: 100%;
  height: 100%;
`

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  flex: 1 0 0;
  padding: 12px 16px;
  width: 100%;
`

const TextArea = styled.textarea`
  width: 100%;
  display: flex;
  padding: 10px;
  justify-content: center;
  align-items: flex-start;
  gap: 10px;
  align-self: stretch;
  border: 1px solid #ececec;

  overflow: hidden;
  color: #3e3e3e;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;

  &::placeholder {
    color: #616161;
  }
`

const RadioText = styled.p`
  color: #3e3e3e;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px; /* 142.857% */
  margin: 0;
  width: unset;
`

const RadioWrappers = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  align-self: stretch;
  flex-wrap: wrap;

  @media (min-width: 1000px) {
    flex-wrap: nowrap;
  }
`

const InputSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 12px;
  align-self: stretch;
`

const TextsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  align-self: stretch;
`

const Title = styled.h3`
  ${({ lighter }) => (lighter ? '#3E3E3E' : '#1D1E22')};
  font-size: 14px;
  font-style: normal;
  font-family: Nunito;
  font-weight: 700;
  line-height: 20px;
  margin: 0;
  text-transform: unset;
  text-align: left;
  letter-spacing: unset;
`

const Description = styled.p`
  color: #3e3e3e;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  margin: 0;
`

const Advice = styled.div`
  display: flex;
  width: 310px;
  padding: 24px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
  background: linear-gradient(270deg, #006736 -58.87%, #93c13e 100%);
`

const AdviceTitle = styled.h1`
  align-self: stretch;
  color: #fff;
  font-family: Nunito;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 32px; /* 133.333% */
  text-transform: uppercase;
  margin: 0;
`

const AdviceText = styled.p`
  color: #fff;
  font-feature-settings: 'liga' off, 'clig' off;
  font-family: Nunito;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  margin: 0;
`

const BtnsWrapper = styled.div`
  display: flex;
  padding: 16px;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  align-self: stretch;
  border-top: 1px solid #ececec;
`



// WEBPACK FOOTER //
// ./src/components/FeedbackContent/index.js